import { isAccommodationItem } from 'lib/checkout/checkoutUtils'

const getOccupantsFromCheckoutCart = (cartItems: Array<App.Checkout.AnyItem>): App.Occupants | undefined => {
  if (!cartItems.length) return
  const findFirstAccommodationItem = cartItems.find(isAccommodationItem)
  return findFirstAccommodationItem?.occupancy
}

export default getOccupantsFromCheckoutCart
